import { useTheme } from '@mui/material';
import { useId, type ReactNode } from 'react';
import { checkboxIconColors } from './checkboxIconPalette';

interface CheckboxFilledIconProps {
  children: ReactNode;
}

export default function CheckboxFilledIcon({ children }: CheckboxFilledIconProps) {
  const { palette } = useTheme();
  const gradientId = useId().replace(/:/g, '');
  const { dark, fill, mark } = checkboxIconColors(palette);

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="4" fill={fill(gradientId)} />
      <g fill={mark}>{children}</g>
      {dark ? null : (
        <defs>
          <linearGradient
            id={gradientId}
            x1="20.155"
            y1="19.2063"
            x2="-2.84595"
            y2="14.0588"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={palette.primary['900']} />
            <stop offset="0.327149" stopColor={palette.primary['800']} />
            <stop offset="0.636347" stopColor={palette.primary['700']} />
            <stop offset="1" stopColor={palette.primary['600']} />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}
